export const isJsonResponse = (response: Response) => {
  // used to ensure that the response is JSON
  const contentType = response.headers.get('content-type');
  return contentType ? contentType.includes('application/json') : false;
};
